import React from 'react';
import MpnFenBonusResults from "components/sports/mpn/fen/results/MpnFenBonusResults";
import 'styles/modules/MpnFencing.scss';
import Status from "components/presentation/Status";
import CaptionTable from "components/general/table/CaptionTable";


const MpnFencingBonus = ({ data }) => {
    let results = data?.results

    let resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;

    return (
        <>
            {(results) &&
                <CaptionTable rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />} />
            }
            <MpnFenBonusResults data={results} />
        </>
    )
};

export default MpnFencingBonus;
